import { render, staticRenderFns } from "./card-tertiary.vue?vue&type=template&id=31678a01&scoped=true&"
import script from "./card-tertiary.vue?vue&type=script&lang=js&"
export * from "./card-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31678a01",
  null
  
)

export default component.exports